// extracted by mini-css-extract-plugin
module.exports = {"container":"calculator-module--container--3isTQ","navButton":"calculator-module--nav-button--3KTVL"};